import moment from 'moment';

export const subtractDayInMoment = (daysToSubtract, start) => {
    const startMoment = start ? moment(start) : moment.parseZone();
    const dayInMilliseconds = 24 * 60 * 60 * 1000;

    // Subtract daysToSubtract converted in milliseconds from the start date.
    return moment.parseZone(startMoment.subtract(daysToSubtract * dayInMilliseconds, 'milliseconds'));
};

export const subtractDay = (daysToSubtract, start) => {
    return subtractDayInMoment(daysToSubtract, start).format();
}

export function getRangeBeforeCampaign(selected) {
    const { start, end } = selected;
    const startMoment = moment(start);
    const endMoment = moment(end);
    const dayInMilliseconds = 24 * 60 * 60 * 1000;
    const dayDifferenceInMilliSeconds = endMoment.valueOf() - startMoment.valueOf();

    // New endDate should be the OriginalStartDate - 1 day.
    const endDateBeforeRange = moment.parseZone(startMoment.subtract(dayInMilliseconds, 'milliseconds')).format();

    // New startDate should be OriginalStartDate - TotalRangeDays - 1 day.
    const startDateBeforeRange = moment.parseZone(startMoment.subtract(dayDifferenceInMilliSeconds - dayInMilliseconds, 'milliseconds')).format();
    return {
        start: startDateBeforeRange,
        end: endDateBeforeRange
    };
  }

export const getDateRangeListByFunction = (convertFunc) => {
    return {
        1: {
            label: "Today",
            value: 1,
            start: convertFunc(0),
            end: convertFunc(0)
        },
        2: {
            label: "Yesterday",
            value: 2,
            start: convertFunc(1),
            end: convertFunc(1)
        },
        3: {
            label: "Last 30 days",
            value: 3,
            start: convertFunc(29),
            end: convertFunc(0)
        },
        4: {
            label: "Last 90 days",
            value: 4,
            start: convertFunc(89),
            end: convertFunc(0)
        }
    }
}

export const DATE_RANGE_LIST_DEFAULT = getDateRangeListByFunction(subtractDay);

const NONVALUE_DATERANGE = {
        label: "MM/DD/YYYY - MM/DD/YYYY",
        value: 0
    }

const CUSTOM_VALUE = -1;

export const ADVERTISER_WO_CAMPAIGN_RANGE = {
    start: subtractDay(7),
    end: subtractDay(1)
}

export default {
    CUSTOM_VALUE,
    DATE_RANGE_LIST_DEFAULT,
    NONVALUE_DATERANGE,
};
